import React, { useEffect, useState } from 'react';
import { BCTabContainer } from './BCTabContainer';
import { translate } from '../../../Services/translation';
import { BCUserRow } from '../BCUserRow';
import { useBCApi } from '../hooks/BCApi';
import { BCConfirmationModal } from '../BCConfirmationModal';
import { BCSpinner } from '../BCSpinner';
import constants from '../../../constants';

export const Users = () => {
  const [users, setUsers] = useState([]);
  const [userToDelete, setUserToDelete] = useState(null);
  const [showAddUser, setShowAddUser] = useState(false);

  const { status, value, error, execute } = useBCApi(
    '/api/bcmypages/users',
    true
  );
  const deleteRequest = useBCApi(`/api/bcmypages/users`);
  const createRequest = useBCApi(`/api/bcmypages/users`);

  useEffect(() => {
    if (deleteRequest.status === 'success') {
      execute();
    }
  }, [deleteRequest.status, execute]);

  useEffect(() => {
    if (createRequest.status === 'success') {
      setShowAddUser(false);
      execute();
    }
  }, [createRequest.status, execute]);

  useEffect(() => {
    if (status === 'success') {
      setUsers(value.users);
    }
  }, [status, value]);

  return (
    <BCTabContainer title={translate('business.userstab.header')}>
      <div className="BusinessCentral__usersTabContent">
        <h3 className="BusinessCentral__usersTabContent__title">
          {translate('business.userstab.userlist')}
        </h3>
        <div className="BusinessCentral__usersTabContent__table">
          <div className="BusinessCentral__usersTabContent__table__header">
            <div className="BusinessCentral__usersTabContent__table__header__item">
              {translate('business.userstab.userlist.name')}
            </div>
            <div className="BusinessCentral__usersTabContent__table__header__item">
              {translate('business.userstab.userlist.email')}
            </div>
            <div className="BusinessCentral__usersTabContent__table__header__item">
              {translate('business.userstab.userlist.role')}
            </div>
            <div className="BusinessCentral__usersTabContent__table__header__item" />
          </div>
          {status === 'pending' ? (
            <div className="BusinessCentral__usersTabContent__table__loading">
              <BCSpinner />
            </div>
          ) : (
            <div className="BusinessCentral__usersTabContent__table__body">
              {users.length > 0 &&
                users?.map((user, index) => (
                  <BCUserRow
                    key={user.id + index}
                    user={user}
                    isOrderApprover={value.isOrderApprover}
                    onDelete={() => setUserToDelete(user)}
                    fetch={() => execute()}
                  />
                ))}
              {showAddUser && value?.isOrderApprover && (
                <BCUserRow
                  createForm
                  createRequest={createRequest}
                  user={{
                    firstName: '',
                    lastName: '',
                    email: '',
                    role: constants.role[Object.keys(constants.role)[0]],
                    editable: true,
                  }}
                  isOrderApprover={value.isOrderApprover}
                  onDelete={() => setShowAddUser(!showAddUser)}
                  fetch={() => execute()}
                />
              )}
              {value?.isOrderApprover && (
                <button
                  className="BusinessCentral__usersTabContent__table__body__add-button"
                  disabled={showAddUser}
                  onClick={() => setShowAddUser(true)}
                >
                  <p>{translate('business.userstab.userlist.addnewuser')}</p>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      <BCConfirmationModal
        isOpen={userToDelete !== null}
        title={translate('business.userstab.userlist.deleteuser')}
        text={translate('business.userstab.userlist.deleteuserconfirmation')}
        onConfirm={() => {
          deleteRequest.execute('DELETE', userToDelete.systemId);
          setUserToDelete(null);
        }}
        onRequestClose={() => setUserToDelete(null)}
      />
    </BCTabContainer>
  );
};
